var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"16","cy":"16","r":"16","fill":"#F5F0FE","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24 16C24 20.4183 20.4183 24 16 24C11.5817 24 8 20.4183 8 16C8 11.5817 11.5817 8 16 8C20.4183 8 24 11.5817 24 16ZM16.5 12C16.7762 12 17 12.2239 17 12.5V15.1111H19.5C19.7762 15.1111 20 15.335 20 15.6111V16.6111C20 16.8873 19.7762 17.1111 19.5 17.1111H17V19.5C17 19.7761 16.7762 20 16.5 20H15.5C15.2239 20 15 19.7761 15 19.5V17.1111H12.5C12.2239 17.1111 12 16.8873 12 16.6111V15.6111C12 15.335 12.2239 15.1111 12.5 15.1111H15V12.5C15 12.2239 15.2239 12 15.5 12H16.5Z","fill":"#6366F1","key":1})]);
}

Plus.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Plus;

Plus.default = Plus;
